module.exports = __webpack_public_path__ + "5bc6b8b7cbb8bea4467c6675e8c35245.MP3";